import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import { Link } from "@react-navigation/native";

import { ButtonLinkProps } from "./types";
import * as Styled from "./styles";

const ButtonLink = <ParamList extends ReactNavigation.RootParamList>({
  to,
  disabled,
  children,
  ...props
}: ButtonLinkProps<ParamList>) => (
  <Styled.LinkWrapper {...{ disabled }}>
    <Link {...{ to, disabled }}>
      <Button {...{ ...props, disabled }}>{children}</Button>
    </Link>
  </Styled.LinkWrapper>
);

export default ButtonLink;
